<template>
<!-- 科目管理 弹窗：编辑科目/创建科目 -->
    <el-dialog :title="form.id?editTextConfig.title:createTextConfig.title" v-if="dialogVisible" :visible.sync="dialogVisible" width="500px" @close="close" :close-on-click-modal="false" :close-on-press-escape="false">
        <el-form :model="form" :rules="rules" ref="form" label-width="80px">
            <el-form-item :label="createTextConfig.subjectName" prop="name">
                <el-input v-model="form.name" maxlength="100" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="createTextConfig.credentialLevel" prop="credential_level">
                <el-select v-model="form.credential_level" clearable>
                    <el-option v-for="item in $parent.gradeOptions" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="createTextConfig.credentialNumber" prop="credential_number">
                <el-input v-model="form.credential_number" maxlength="50" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="createTextConfig.credentialName" prop="credential_name">
                <el-input v-model="form.credential_name" maxlength="100" show-word-limit clearable></el-input>
            </el-form-item>
            <el-form-item :label="createTextConfig.examType" prop="exam_type">
                <el-select v-model="form.exam_type" clearable allow-create filterable>
                    <el-option v-for="item in $parent.typeOptions" :key="item.dict_value" :label="item.dict_label" :value="item.dict_value"></el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">{{ createTextConfig.cancel }}</el-button>
            <el-button type="primary" @click="submitForm('form')">{{ createTextConfig.ok }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: ['row', 'show'],
    data() {
        return {
            dialogVisible: false,
            form: {
                id: null,
                name: '',
                credential_level: '',
                credential_number: '',
                credential_name: '',
                exam_type: '',
            },
            rules:{
                name: [
                    { required: true, message: this.$store.state.global.textConfig.backend.subject.create.subjectNameRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (/^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入中英文、数字、圆括号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                credential_level: [
                    // { required: true, message: this.$store.state.global.textConfig.backend.subject.create.credentialLevelRule, trigger: 'change' },
                ],
                credential_number: [
                    // { required: true, message: this.$store.state.global.textConfig.backend.subject.create.credentialNumberRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (/^[0-9]*$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入数字"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                credential_name: [
                    // { required: true, message: this.$store.state.global.textConfig.backend.subject.create.credentialNameRule, trigger: 'change' },
                    {
                        validator: function(rule, value, callback) {
                            if (/^[\u4E00-\u9FA5A-Za-z0-9()（）]+$/g.test(value) == false && value) {
                                callback(new Error("仅支持输入中英文、数字、圆括号"));
                            } else {
                                callback();
                            }
                        },
                        trigger: "change"
                    }
                ],
                exam_type: [],
            },
        };
    },
    computed: {
        createTextConfig() {
            return this.$store.state.global.textConfig.backend.subject.create
        },
        editTextConfig() {
            return this.$store.state.global.textConfig.backend.subject.edit
        }
    },
    watch: {
        show() {
            this.dialogVisible = this.show;
        },
        row() {
            if (this.row) {
                this.form = {
                    id: this.row.id,
                    name: this.row.name,
                    credential_level: this.row.credential_level,
                    credential_number: this.row.credential_number,
                    credential_name: this.row.credential_name,
                    exam_type: this.row.exam_type
                }
            }else {
                this.form.id = null
            }
        }
    },
    methods: {
        close() {
            this.dialogVisible = false
            this.$emit('close', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        this.$store.dispatch("putSubject", this.form).then(res => {
                            if (res.status == 200) {
                                this.$message({
                                    message: this.editTextConfig.success,
                                    type: 'success'
                                });
                                this.close()
                                this.$parent.search()
                            }
                        });
                    }else {
                        this.$store.dispatch("checkRepeatSubject", this.form.name).then(res => {
                            if (res.data === false) {
                                this.$store.dispatch("postSubject", this.form).then(res => {
                                    if (res.status == 200) {
                                        this.$message({
                                            message: this.createTextConfig.success,
                                            type: 'success'
                                        });
                                        this.close()
                                        this.$parent.search(1)
                                    }
                                });
                            }else {
                                this.$message({
                                    message: this.createTextConfig.already,
                                    type: 'error'
                                });
                            }
                        });
                    }

                } else {
                    return false;
                }
            });
        },
    }
};
</script>

<style>

</style>